import { render, staticRenderFns } from "./schoolTW.vue?vue&type=template&id=fbbcaba0&scoped=true&"
import script from "./schoolTW.vue?vue&type=script&lang=js&"
export * from "./schoolTW.vue?vue&type=script&lang=js&"
import style0 from "./schoolTW.vue?vue&type=style&index=0&id=fbbcaba0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbbcaba0",
  null
  
)

export default component.exports